module.exports = __webpack_public_path__ + "static/media/plan-mas-250gb.8d3c3f3d.svg";